<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<v-row>
			<v-col cols="12" style="padding:0 40px 40px">
				<v-row>
					<v-col cols="12" md="3">
					</v-col>
					<v-col cols="12" md="6">
						<date-navigator v-model="dateRange" :options="{rangeMode: true, defaultEmpty: true}" />
					</v-col>
					<v-col cols="12" md="3" class="d-flex align-center justify-end">
						<v-btn color="primary" dark class="mx-1" @click="loadData">
							دریافت اطلاعات
						</v-btn>
						<export-excel :items="items" :headers="headers" :fileName="excelFileName">
						</export-excel>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="12">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="500" :search="search" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td class="text-center">
										{{ `${row.item.saveDate_Persian.date}` }}
									</td>
									<td class="text-center">
										{{ `${row.item.amount.toString().toPriceFormat()}` }}
									</td>
									<td class="text-right" style="white-space:pre" v-html="row.item.description">
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" :data="{member:selectedMember}" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'SponsoredPaids',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			'manage-loan': ManageLoan,
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogLoansManager: false,
				selectedMember: {},
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'تاریخ',
						align: 'center',
						sortable: false,
						value: 'saveDate_Persian.date',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: false,
						value: 'amount',
					}, {
						text: 'شرح',
						align: 'right',
						sortable: false,
						value: 'description',
					}
				],
				items: [],
				dateRange: { start: '', end: '' }
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست پرداختی های اسپانسری ' + this.data.title
				if (this.startDate)
					name += ' از ' + this.startDate.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
		},
		mounted() {
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/report/SponsoredPaids/?start=' + `${this.dateRange.start}&end=${this.dateRange.end}&loanId=${this.data.id}`, {})
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style>
</style>
